import { useUserAssignedRolesApi } from 'api/useUserAssignedRoles'
import { useUserQuery } from 'queries/useUserQuery'

export function useIsAdmin() {
  const { data: user } = useUserQuery()

  const { data: userAssignedRoles } = useUserAssignedRolesApi({
    params: { email: user?.email || '', id: user?.id || '' },
    enabled: !!user?.email && !!user?.id,
  })
  return {
    isAdmin:
      !userAssignedRoles ||
      userAssignedRoles.some((role: { role_name: string }) => role.role_name.toLowerCase() === 'tccc-bva-admin'),
  }
}
